import addError from '../../../utils/error.jsx';
import { request as getRoles } from '../actions/get';

export function request(id) {
    return {
        type: 'ROLE_DELETE_REQUEST',
        id
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'ROLE_DELETE_ERROR',
        errors
    };
}

export function finish(id) {
    return (dispatch) => {
        dispatch(getRoles());
        dispatch({
            type: 'ROLE_DELETE_FINISH',
            id
        });
    };
}
